import { render, staticRenderFns } from "./trainCode.vue?vue&type=template&id=19bd0aba&scoped=true&"
import script from "./trainCode.vue?vue&type=script&lang=ts&"
export * from "./trainCode.vue?vue&type=script&lang=ts&"
import style0 from "./trainCode.vue?vue&type=style&index=0&id=19bd0aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd0aba",
  null
  
)

export default component.exports